import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box, Typography } from "@mui/material"


export default function MoreLessInfo({ moreText = "Show description...", lessText = "Less description...", children }) {
    const isShow = useSignal(false)

    return <Box>
        { !!isShow.value && children }
        <Typography variant="subtitle2" sx={{ cursor: "pointer" }} onClick={() => isShow.value = !isShow.value}>
            { isShow.value ? lessText : moreText }
        </Typography>
    </Box>
}